import { HttpHeaders, HttpParams } from "@angular/common/http";
import { ApiService } from "./api.service";
import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { BehaviorSubject, Observable } from "rxjs";
import { Response } from "src/app/shared/models/response.model";
import { DataWithPage } from "src/app/shared/models/data-with-page.model";
import { FormData } from "src/app/shared/models/form-data.model";
import { SignatureConfig } from "src/app/shared/models/signature-config.model";

const API_GET_ALL_SIGNATURE = "/dc/signatures/get-all";
const API_SAVE_ALL_SIGNATURE = "/dc/signatures/save-all";
const API_DELETE_SIGNATURE = "/dc/signatures/delete-all";

@Injectable({
  providedIn: "root",
})
export class SignatureConfigService {
  constructor(private apiService: ApiService) {}

  getAllSignature(id: number): Observable<Response<Array<SignatureConfig>>> {
    return this.apiService.get(`${API_GET_ALL_SIGNATURE}?templateId=${id}`).pipe(
      map((res) => {
        return res;
      })
    );
  }

  saveSignature(id: number, body: SignatureConfig[]):  Observable<Response<Array<SignatureConfig>>> {
    return this.apiService.post(`${API_SAVE_ALL_SIGNATURE}?templateId=${id}`, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  deleteSignature(id: number) {
    return this.apiService.post(`${API_DELETE_SIGNATURE}?templateId=${id}`, [id]).pipe(
      map((res) => {
        return res;
      })
    );
  }
}
